<template>
  <div class="notice-edit-modal">
    <b-modal id="modal-prevent-closing" ref="modal" size="xl" centered
             no-close-on-backdrop
             header-class="bg-modal-header"
             @ok="handleOk"
             @cancel="handleCancel">

      <template #modal-header>
        <div class="fw-bold">EVON 공지사항 관리</div>
      </template>

      <div class="row justify-content-center">
        <div class="col-11 form-group">
          <label for="title-input" class="col-form-label">공지 제목</label>
          <b-form-input
              id="title-input"
              v-model="form.title"
          />
        </div>
      </div>

      <div class="row justify-content-center mt-2">
        <div class="col-11 form-group">
          <label for="contents-input" class="col-form-label">공지 내용</label>
          <editor ref="toastuiEditor"
                  initialEditType="wysiwyg"
                  height="500px"
                  :initialValue="editorText"
                  :options="editorOptions"
                  @change="onEditorChange" />
        </div>
      </div>

      <form method="post" enctype="multipart/form-data">
        <div class="row justify-content-center">
          <div class="col-11 form-group row attach-file-group">
            <input class="file-name-input col" v-model="fileName" placeholder="첨부파일 (최대용량 10MB)"/>
            <label for="file-upload" id="upload-label">파일찾기</label>
            <button class="file-delete-btn" :style="fileName ? 'display: block' : 'display: none'"
                    @click="deleteAttachFile">
              <i class="mdi mdi-close"/>
            </button>
            <input type="file" id="file-upload" hidden @change="handleFileChange"/>
            <span v-if="fileName" class="col-1 pt-3 pe-0 text-end text-danger"> ({{ fileSize }}) </span>
          </div>
        </div>
      </form>

      <template #modal-footer="{ ok, cancel }">

        <b-button variant="secondary" @click="cancel()">
          닫기
        </b-button>

        <!-- Button with custom close trigger value -->
        <b-button variant="primary" @click="ok()">
          {{ mode === 'create' ? '등록' : '수정' }}
        </b-button>
      </template>


    </b-modal>
  </div>

</template>

<script>
import '@toast-ui/editor/dist/toastui-editor.css';
import { Editor } from '@toast-ui/vue-editor';
import '@toast-ui/editor/dist/i18n/ko-kr'

export default {
  name: "NoticeEditModal",
  props: {
    mode: String,
  },
  components: { editor: Editor },
  data() {

    return {
      editorText: null,
      editorOptions: {
        language: 'ko',
        hooks: {
          addImageBlobHook: this.addImageBlobHook
        }
      },
      form: {
        title: null,
        contents: null,
        file: null,
      },
      fileName: null,
      fileSize: null,
      previewImageData: null
    }
  },
  methods: {
    onEditorChange() {
      const vm = this;
      let html = this.$refs.toastuiEditor.invoke('getHTML');

      vm.form.contents = html === `<p><br></p>`? null : html
    },
    addImageBlobHook(file, setText, type) {
      console.log('file 1 :: ', file)
      console.log('file 2 :: ', setText)
      console.log('file 3 :: ', type)

      try {
        if (!file) return false;

        console.log('file Size :: ', file.size)

        if (file && file.size > 5242880) {
          const size = (file.size / (1024 * 1024)).toFixed(1);

          console.log('최대 업로드 사이즈(5 MB)를 초과', size)
          return false;
        }


        const formData = new FormData();
        formData.append("file", file);

        this.$axios.post(`/onmapi/file/create`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          console.log('result !!! ', res)
          if (res.status === 201) {
            setText(`https://ev.i-on.net/onmapi/file/image/view/${res.data.fileInfo.fileId}`, 'image');
          }
        }).catch(err => {
          console.log(err);
          this.$swal('등록 실패', '등록에 실패하였습니다.', 'error')
        });

      } catch (err) {
        console.log(err)
      }
    },
    showModal(content) {
      const vm = this;

      vm.$refs.modal.show();
      if (this.mode === 'update') {
        console.log('updateContent: ', content)
        vm.form = Object.assign({}, content);
        vm.editorText = vm.form.contents;

        if (content.attachFile) {
          console.log(content.attachFile.orgName);
          vm.fileName = content.attachFile.orgName;
          vm.fileSize = content.attachFile.fileSize > 1024 ? `${Math.round((content.attachFile.fileSize/1024)*10)/10}MB` : `${content.attachFile.fileSize}KB`;
        }
      }
    },
    handleFileChange(e) {
      const vm = this;

      const size = e.target.files[0].size;
      const unit = ['bytes', 'KB', 'MB'];
      const num = Math.floor(Math.log(size) / Math.log(1024));

      vm.checkFileSize (10, e);
      vm.form.file = e.target.files[0];
      vm.fileName = e.target.files[0].name ;
      vm.fileSize = `${Math.round((size/Math.pow(1024, num))*10)/10}${unit[num]}`
    },
    checkFileSize (limitSize, evt) {
      const vm = this;

      const maxSize = limitSize * 1024 * 1024;
      const fileSize = evt.target.files[0].size;

      if (evt.target.files && evt.target.files[0]) {
        console.log(evt.target.files);
        if (fileSize > maxSize) {
          this.$swal('첨부파일 용량 초과', `${limitSize} MB이하의 파일만 등록 가능합니다.`, 'error')
            .then(()=> {
              vm.form.file = null;
              vm.fileName = null;
              vm.fileSize = null;
            })
        }
      }
    },
    deleteAttachFile(e) {
      const vm = this;

      e.preventDefault();

      if (vm.mode === 'update' && !this.$_utils.isEmpty(vm.form.attachFile)) {
        console.log('noticeId', vm.form.id)
        console.log('deleteFId:', vm.form.attachFile.fileId)

        this.$swal({
          title: '첨부파일을 삭제하시겠습니까?',
          text: '삭제된 파일은 복구할 수 없습니다.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: '확인',
          cancelButtonText: '취소',
        }).then(result => {
          if (result.isConfirmed) {
            this.$axios.delete(`onmapi/notice/delete/file/${vm.form.id}`)
              .then(res => {
                console.log(res);
                delete vm.form.attachFile;
                vm.fileName = null;
                vm.fileSize = null;
              })
              .catch(err => {
                console.log(err);
              });
          }
        });
      } else if (vm.mode === 'create' && !this.$_utils.isEmpty(vm.form.attachFile)) {
        vm.form.file = null;
        vm.fileName = null;
        vm.fileSize = null;
      }
    },
    handleOk(bvModalEvent) {
      const vm = this;

      bvModalEvent.preventDefault();
      vm.save();
    },
    save() {
      const vm = this;
      let entity = vm.form;

      if (this.$_utils.isEmpty(vm.form.title)) {
        this.$swal('제목을 입력해주세요', '', 'warning');
        throw new Error("title input empty");
      }
      if (this.$_utils.isEmpty(vm.form.contents)) {
        this.$swal('본문 내용을 입력해주세요', '', 'warning');
        throw new Error("contents input empty");
      }

      if (this.mode === 'create') {
        console.log('entity : ', entity)
        this.$axios.post(`/onmapi/notice/create`, entity, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          this.$swal('등록완료', '등록이 완료되었습니다.', 'success')
            .then(result => {
              if (result.isConfirmed) {
                vm.closeModal();
                this.$emit('change-notice-mode', 'list');
              }
            })
        }).catch(err => {
          console.log(err);
          this.$swal('등록 실패', '등록에 실패하였습니다.', 'error')
        });

      } else if (this.mode === 'update') {

        this.$axios.patch(`/onmapi/notice/update`, entity, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => {
          this.$swal('수정완료', '수정이 완료되었습니다.', 'success')
            .then(result => {
              if (result.isConfirmed) {
                vm.closeModal();
                this.$emit('change-notice-mode', 'list');
              }
            })
        }).catch(err => {
          console.log(err);
          this.$swal('수정 실패', '수정에 실패하였습니다.', 'error');
        });
      }
    },
    handleCancel(bvModalEvent) {
      const vm = this;

      bvModalEvent.preventDefault();

      if (this.mode === 'create') {
        this.$swal({
          title: '등록을 취소하시겠습니까?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: '확인',
          cancelButtonText: '취소',
        }).then(result => {
          if (result.isConfirmed) {
            vm.closeModal();
            this.$emit('change-notice-mode', 'list');
          }
        });

      } else if (this.mode === 'update') {
          this.$swal({
            title: '수정을 취소하시겠습니까?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: '확인',
            cancelButtonText: '취소',
          }).then(result => {
            if (result.isConfirmed) {
              vm.closeModal();
              this.$emit('change-notice-mode', 'list');
            }
          });
      }
    },
    closeModal() {
      const vm = this;

      vm.form = Object.assign({}, null);
      vm.fileName = null;
      vm.fileSize = null;
      vm.editorText = null;
      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing');
      })
    },
  },
}
</script>